import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Store } from '@ngrx/store';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ClearBidSheet } from '../../../../../../core/projects.actions';
import { ChangeOrdersRequestService } from '../change-orders-request.service';

@Component({
    selector: 'app-change-orders-request-filters',
    templateUrl: './change-orders-request-filters.component.html',
    styleUrls: ['./change-orders-request-filters.component.scss'],
    standalone: false
})
export class ChangeOrdersRequestFiltersComponent implements OnInit, OnDestroy {
  @ViewChild('sortSelect') sortSelect: MatSelect;

  defaultDateValue = 'All time';
  form = new FormGroup({
    searchText: new FormControl(''),
  });
  selectedSortColumn: string | null = 'Change order #';
  sortByColumns: string[] = ['Change order #', 'Amount change', 'Work days change', 'Status', 'Created at'];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public dialog: MatDialog,
    private store: Store,
    private changeOrdersRequestService: ChangeOrdersRequestService,
  ) {

  }

  ngOnInit() {
    this.form.controls.searchText.valueChanges
      .pipe(debounceTime(200), takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.changeOrdersRequestService.search.next(data);
      });
  }

  search() {
    const { searchText } = this.form.getRawValue();
    this.changeOrdersRequestService.search.next(searchText);
  }

  close() {
    this.form.reset();
    const searchText = '';
    this.changeOrdersRequestService.search.next(searchText);
  }

  openSortDropdown(event?: Event): void {
    // Material renders the select panel and its backdrop as an inline popover
    // *inside* this wrapper, so the click that closes the panel bubbles back
    // here and would reopen it. Only react to clicks on the button itself.
    const target = event?.target as HTMLElement | null;
    if (target?.closest('.cdk-overlay-popover, .cdk-overlay-backdrop')) return;
    this.sortSelect?.open?.();
  }

  onSortColumnChange(event: any): void {
    this.selectedSortColumn = event.value;
    this.changeOrdersRequestService.sort.next({ column: this.selectedSortColumn, direction: 'asc' });
  }

  removeSort(event: Event): void {
    event?.stopPropagation();
    this.selectedSortColumn = null;
    this.changeOrdersRequestService.sort.next({ column: null, direction: 'asc' });
  }

  ngOnDestroy() {
    this.store.dispatch(ClearBidSheet());
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
